$(function(){
  setupActionEditField();
})

function editFieldCreateForm(value, btn, target){
  var input = $('<input class="edit-field newvalue">');

  var submit = $('<a type="submit" class="btn-edit normal-margin btn-action-hideAfter margin-left-10 btn-action-editField">' +
      '<span class="glyphicon glyphicon-ok glyphicon-green for-edit margin-right-5"></span>'+
      '<span class="text"><span class="for-edit"></span></span></a>');
  var cancel = $('<a type="submit" class="btn-edit normal-margin btn-action-hideAfter margin-left-5 btn-action-editField">' +
  '<span class="glyphicon glyphicon-remove glyphicon-red for-edit margin-right-5"></span>'+
  '<span class="text"><span class="for-edit"></span></span></a>');

  var formDiv = $('<div class="display-inline-block"><form class="edit-field-form whitespace-nowrap"></form></div>');
  var form = $('form', formDiv);

  input.val(value).appendTo(form);
  submit.click(function(){form.submit()}).appendTo(form);
  cancel.appendTo(form);

  cancel.click(function(){
    form.replaceWith(target);

     //only for names in _divisionDetail_players.latte
     if(btn.hasClass('mergeTableCells'))
     {
       $(btn.attr('data-firstCell')).attr('colspan', 1);
       $(btn.attr('data-secondCell')).show();
     }

     
    btn.show();
    return;
  });


  form.data('targetclass', target.prop('class'));
  form.data('targetid', target.prop('id'));
  form.data('targettagname', target.prop('tagName'));
  form.data('posturl', btn.data('posturl'));
  form.data('id', btn.data('id'));
  form.data('reload', btn.data('reload'));

  form.submit(function(e){editFieldSubmited(e, form, btn);});

  $('body').addClass('editing-field');
  setTimeout(function() {
      input.focus();
  }, 0);
  input[0].selectionStart = input[0].selectionEnd = input.val().length;
  return form;
}

function editFieldSubmited(e, form, btn){
  e.preventDefault();
 
 var loadingSpinner = $('<div class="loading-spinner-green inline-block w-[20px] h-[20px] margin-left-15"></div>');
 loadingSpinner.appendTo(form);

  //var spinner = $($spinnerHTML);
  //spinner.appendTo(form);
  //var mTop = parseInt($('.newvalue', form).css('marginTop').slice(0, -2)) / 2 
  //spinner.addClass('display-inline-block').css({
  //  marginTop: mTop
  //});

  $.post({
    url: form.data('posturl'),
    data: {
      newvalue: $('.newvalue', form).val(),
      id: form.data('id')
    },
    dataType: 'json',
    success: function(data)
    {
      $('loading-spinner').remove();
      $('.loading-spinner').remove();
      $('.loading-spinner-green').remove();
      if(data.isSuccess){

        if(data.reload && (form.data('reload') == 'undefined' || form.data('reload') == true)) 
        {
          window.location.reload();
        } 
        else 
        {
          var target = $('<' + form.data('targettagname') + '>').addClass(form.data('targetclass')).prop('id', form.data('targetid'));
          target.prop("href", btn.data('href'));
          target.data('editvalue', $('.newvalue', form).val());
          target.text($('.newvalue', form).val());
          form.replaceWith(target);
          btn.show();
        }

      } else{
        $('.errormessage', form).remove();
        $('<div>')
          .text(data.message)
          .addClass('errormessage text-red font-size-13px')
          .appendTo(form);
      }
    }
  });
}

function setupActionEditField() {
  $('.btn-action-editField').each(function(){
    var btn = $(this);

    btn.click(function(){

      //only for names in _divisionDetail_players.latte
      if(btn.hasClass('mergeTableCells'))
      {
        $(btn.attr('data-firstCell')).attr('colspan', 2);
        $(btn.attr('data-secondCell')).hide();
      }


      btn.hide();
      var target = $(btn.data('target'));
      var form = editFieldCreateForm(target.data('editvalue'), btn, target);
      target.replaceWith(form);
    });
  });
}


